export default {"src":"/_next/static/media/wishlist.9abe8f62.svg","height":24,"width":24};